var $1d0fa5f3cc68e5b0$exports = {};
$1d0fa5f3cc68e5b0$exports = {
    "dismiss": `Negeren`
};


export {$1d0fa5f3cc68e5b0$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
